import { useInfiniteQuery } from '@tanstack/react-query'
import { userNotificationsControllerListNotifications } from 'api.gen'
import type { ListUserNotificationsResponse, UserNotification } from '../types'

const PAGE_SIZE = 20

export const useUserNotifications = () => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: ['user-notifications'],
      queryFn: async ({ pageParam = 1 }) => {
        const response = await userNotificationsControllerListNotifications({
          page: pageParam,
          limit: PAGE_SIZE
        })
        return response.data as unknown as ListUserNotificationsResponse
      },
      getNextPageParam: lastPage => {
        if (lastPage.meta.page < lastPage.meta.totalPages) {
          return lastPage.meta.page + 1
        }
        return undefined
      },
      initialPageParam: 1,
      refetchInterval: 30_000
    })

  const notifications: UserNotification[] =
    data?.pages.flatMap(page => page.data) ?? []

  return {
    notifications,
    isLoading,
    hasMore: hasNextPage ?? false,
    fetchMore: fetchNextPage,
    isFetchingMore: isFetchingNextPage
  }
}
